import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import afterPaint from '../../../js/__utils/afterPaint';

document.addEventListener('DOMContentLoaded', function () {
	const sliders = document.querySelectorAll(
		'.block-content-card-slider .swiper'
	);
	const sliderViewCount = 2;
	const centeredSlides = false;
	const centeredSlidesMobile = false;

	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const progressBar = slider
				.closest('.block-content-card-slider__container')
				.querySelector('.block-cards__progress');

			const settings = {
				loop: false,
				grabCursor: true,
				slidesPerView: sliderViewCount,
				spaceBetween: 20,
				slidesPerGroup: 3,
				centeredSlides,
				modules: [A11y, Navigation, Pagination],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
				},
				navigation: {
					prevEl: slider
						.closest('.block-content-card-slider')
						.querySelector('.swiper-button-prev'),
					nextEl: slider
						.closest('.block-content-card-slider')
						.querySelector('.swiper-button-next'),
				},
				breakpoints: {
					0: {
						spaceBetween: 8,
						slidesPerView: 1,
						slidesPerGroup: 1,
						centeredSlides: centeredSlidesMobile,
					},
					576: {
						spaceBetween: 8,
						slidesPerView: 3,
						slidesPerGroup: 1,
					},
					768: {
						spaceBetween: 20,
						slidesPerView: 3,
						slidesPerGroup: 3,
					},
					1200: {
						spaceBetween: 20,
						slidesPerView: 3,
						slidesPerGroup: 3,
					},
				},
				on: {
					init() {
						// Set initial progress
						updateProgress(this, progressBar);
					},
					slideChange() {
						// Update progress on slide change
						updateProgress(this, progressBar);
					},
				},
			};

			afterPaint(() => {
				new Swiper(slider, settings);
			});
		});
	}

	function updateProgress(swiper, progressBar) {
		if (!progressBar) return;

		const totalSlides =
			swiper.slides.length - swiper.params.slidesPerView + 1;
		const activeSlideIndex = swiper.activeIndex + 1;
		const progressPercentage = (activeSlideIndex / totalSlides) * 100;

		progressBar.style.width = `${progressPercentage}%`;
	}
});
